<script setup lang="ts">
const flags = useFeatureFlags()
const links = useLinks()
const { isMobile } = useDevice()
</script>

<template>
    <nav class="navbar">
        <SelfAssessmentContainer v-if="flags?.enableSelfAssessment" />

        <div class="navbar__content">
            <UIButton
                v-bind="links.login.props()"
                class="login"
                as="link"
                size="sm"
                block
                data-test="nav-bar-button-login"
            >
                <div class="navbar__login">
                    <UIIcon
                        name="login"
                    />
                    <span class="bold">Log in</span>
                </div>
            </UIButton>

            <NuxtImg
                class="navbar__logo"
                provider="cloudflare"
                preset="local"
                src="/media/logo/ht-logo-light-with-shadow.png"
                :modifiers="{ dpr: 2 }"
                :height="isMobile ? '50px' : '75px'"
                alt="Happy Tiger logo"
            />
        </div>
    </nav>
</template>

<style scoped lang="scss">
.navbar {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    z-index: 10;
    background: var(--nav-background, linear-gradient(to bottom, #182138 0%, #182138 60px, transparent 100%));

    &__content {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        justify-items: center;
        align-items: center;
        gap: 10px;
        color: #fff;
        position: static;
        height: 70px;
        max-width: 1024px;
        width: 100%;
        margin: auto;

        .login {
            justify-self: start;
            width: min-content;
            color: var(--login-button-color, black);
        }
    }

    &__login {
        display: flex;
        align-items: center;
        gap: 5px;
    }

    &__logo {
        transform: translateY(6px);

        @include tablet {
            transform: translateY(10px);
        }
    }
}
</style>
